import React from 'react';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import './datePickerComp.css';
import "react-datepicker/dist/react-datepicker.css";

// props:
// date - current monday date selected
// onWeekChange - function to handle week selection

export default function WeekPickerComp(props) {
    const MyContainer = ({ className, children }) => {
        return (
            <div style={{ padding: "16px", background: "#706f6f", color: "#fff" }}>
                <CalendarContainer className={className}>
                    <div style={{ background: "#f0f0f0" }}>
                        Select a week to view bookings
                    </div>
                    <div style={{ position: "relative" }}>{children}</div>
                </CalendarContainer>
            </div>
        );
    };

    return (
        <div className='DatePickerComp'>
            <h1 className='DatePickerHeader'>Week starting - </h1>
            <DatePicker
                selected={props.date}
                dateFormat="dd/MM/yyyy"
                onChange={(date) => props.onWeekChange(date)}
                className='DatePickerClass'
                calendarContainer={MyContainer}
            />
        </div>
    );
}
